<p>sale-configuration-form works!</p>
